import React, { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import './TableRowPlaceholder.styles.scss';

const HORIZONTAL_PADDING = 16;

const TableRowContentLoader = ({
  width,
  ...rest
}: IContentLoaderProps & { width: number | string }) => (
  <ContentLoader
    viewBox={`0 0 ${width} 50`}
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...rest}
  >
    <rect x="0" y="0" rx="16" ry="16" height="50" width={width} />
  </ContentLoader>
);

type TableRowPlaceholderProps = {
  className?: string;
  numberOfColumns: number;
};

const TableRowPlaceholder: React.FC<TableRowPlaceholderProps> = (props) => {
  const { className, numberOfColumns } = props;

  const classes = classNames('table-row-placeholder', className);

  const ref = useRef<HTMLTableRowElement>(null);
  const [width, setWidth] = useState(0);

  const style = useMemo(
    () => (width ? { width, minWidth: width, maxWidth: width } : {}),
    [width],
  );

  useEffect(() => {
    const trElement = ref.current;

    if (trElement && !width) {
      setWidth(trElement.clientWidth - 2 * HORIZONTAL_PADDING);
    }
  }, [width]);

  return (
    <tr className={classes} ref={ref} style={style}>
      <td colSpan={numberOfColumns}>
        <div style={style}>
          <TableRowContentLoader width={width} />
        </div>
      </td>
    </tr>
  );
};

export default TableRowPlaceholder;
